import {
    TableCell,
    TableRow,
    Theme,
    Typography
} from "@mui/material";
import { FundHousePerformanceData } from "../types";
import { formatCurrency } from "../../../../utils/utilityFunctions";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../../redux-store/reducers";

export default function FundsDataTable({ data }: { data: FundHousePerformanceData[] }): JSX.Element {
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    return (
        <>
            {
                data.map((obj: FundHousePerformanceData, index: number) => {
                    let percentage = 0

                    if (
                        Number.isNaN(Number(obj?.unRelGainLoss ?? 0)) ||
                        Number(obj?.unRelGainLoss ?? 0) === 0 ||
                        Number.isNaN(Number(obj?.investedValue ?? 0)) ||
                        Number(obj?.investedValue ?? 0) === 0
                    ) {
                        percentage = 0
                    } else {
                        // Formula to calculate percentage
                        // ((unRelGainLoss)/investedValue)*100

                        const calculatedPercentage = (Number(obj?.unRelGainLoss ?? 0) / Number(obj?.investedValue ?? 0)) * 100

                        percentage = !Number.isNaN(Number(calculatedPercentage)) ?
                            Math.round((calculatedPercentage) * 100) / 100 : 0
                    }

                    const unrealizedGainLoss = (obj?.unRelGainLoss ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.unRelGainLoss ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.unRelGainLoss ?? 0, locale, currencyCode })}`

                    return (
                        <TableRow
                            key={`${obj.fundHouseId}-${index}`}
                            sx={(theme: Theme) => ({
                                '& td': {
                                    paddingTop: "15px",
                                    paddingBottom: "15px",
                                    borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                },
                                '& td:first-of-type': {
                                    paddingLeft: "0px"
                                },
                            })}
                        >
                            <TableCell align="left">
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.primary,
                                        '&:hover': {
                                            color: theme.palette.primary[500]
                                        },
                                    })}
                                >
                                    {obj?.fundHouseName ?? ""}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.primary,
                                    })}
                                >
                                    {formatCurrency({ value: obj?.investedValue ?? 0, locale, currencyCode })}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.primary
                                    })}
                                >
                                    {formatCurrency({ value: obj?.marketValue ?? 0, locale, currencyCode })}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: (percentage >= 0) ? theme.palette.success[500] : theme.palette.error[500]
                                    })}
                                >
                                    {unrealizedGainLoss} ({percentage}%)
                                </Typography>
                            </TableCell>
                        </TableRow>
                    )
                })
            }
        </>
    )
}